import React from 'react';
import Modal from '../shared/Modal';
import FormsySimpleInput from '../form/FormsySimpleInput';
import Formsy from 'formsy-react';
import { chefAPI } from '../../InterfaceAPI/chefAPI';
import { maskServiceDistricts, adminChefName } from '../../masks';
import { CHEF_ROLES } from '../../const';
import { getLatestRequest } from '../../helpers/util';

import {
  maskDate,
  maskServiceDate,
  maskServiceStartTime,
  maskServiceEndTime
} from '../../masks';

class ServiceAddStaffModal extends React.Component {
  staff = {
    available: [],
    interested: [],
    unavailable: [],
    override: []
  };

  state = {
    lastTerm: '',
    searchTerm: '',
    isLoading: false,
    staff: this.staff,
    activeTab: 'available'
  };

  render() {
    const { handleSearch, loadStaff } = this;
    const { isOpen, closeModal } = this.props;
    const { searchTerm } = this.state;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal modal--no-padding admin-wrapper"
      >
        <div className="modal__head modal__head--flush-bottom">
          <h2 className="h2 modal__heading">Add Staff</h2>
          <Formsy className="form" onValidSubmit={loadStaff}>
            <div className="cms__bar cms__bar--margin-bot">
              <div className="cms__bar-item cms__bar-item--full">
                <FormsySimpleInput
                  type="text"
                  name="searchTerm"
                  placeholder="Enter Staff Name"
                  className="simple-input simple-input--pad-right"
                  value={searchTerm}
                  onChange={handleSearch}
                  autoComplete="off"
                />
              </div>
              <div className="cms__bar-item">
                <input
                  type="submit"
                  value="Search"
                  className="btn btn--solid-blue"
                />
              </div>
            </div>
          </Formsy>

          {this.renderBucketNav()}
        </div>
        <div className="modal__body modal__body--tall">
          {this.state.isLoading ? (
            <p className="p">Loading...</p>
          ) : (
            <div className="add-staff">{this.renderStaffList()}</div>
          )}
        </div>
      </Modal>
    );
  }

  renderBucketNav() {
    return (
      <div className="tabs">
        {Object.keys(this.staff).map((status, i) =>
          this.renderBucketNavItem(status, i)
        )}
      </div>
    );
  }

  renderBucketNavItem(status, i) {
    const className = `tab ${this.state.activeTab === status ? 'active ' : ''}`;
    const onClick = () => this.setState({ activeTab: status });
    return (
      <div key={i} className={className} onClick={onClick}>
        {status}
      </div>
    );
  }

  renderStaffList() {
    const staff = this.state.staff[this.state.activeTab] || [];

    if (staff.length === 0)
      return (
        <div className="add-staff__results staff__results--empty">
          <p className="p">No matching {this.state.activeTab} chefs</p>
        </div>
      );
    else {
      const { start_time, end_time } = this.props.service;

      return (
        <div className="add-staff__results">
          <div className="add-staff__results-count">
            <p className="p">
              <span className="p--bold">
                {staff.length} staff are {this.state.activeTab}{' '}
              </span>
              on {maskServiceDate(start_time)}{' '}
              {maskServiceStartTime(start_time)} {maskServiceEndTime(end_time)}
            </p>
          </div>
          <div className="add-staff__list">
            {staff.map((chef, i) => this.renderStaff(chef, i))}
          </div>
        </div>
      );
    }
  }

  renderStaff(staff, index) {
    const lastService = staff.last_service_to_client
      ? ` Last Service: ${maskDate(staff.last_service_to_client)}`
      : '';
    return (
      <div
        key={index}
        className="add-staff__item p"
        onClick={() => this.addStaff(staff.chef)}
      >
        {adminChefName(staff.chef)}
        {lastService || ''}
        <span style={{ float: 'right' }}>
          {maskServiceDistricts(staff.chef.service_districts || [])}
        </span>
      </div>
    );
  }

  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  loadStaff = () => {
    const { id: service_id, start_time, end_time, client } = this.props.service;
    const { searchTerm: name } = this.state;
    const client_id = client && 'id' in client ? client.id : null;
    const { zipOverride } = this.props
    const search = { service_id, start_time, end_time, client_id, name, zip_code: zipOverride };

    // clear existing
    this.setState({ staff: this.staff, isLoading: true });

    // make request
    getLatestRequest(
      'getAvailableChefs',
      chefAPI.getAvailableChefs(search),
      (staff) => {
        const activeTab =
          Object.keys(staff).filter((key) => staff[key].length > 0)[0] ||
          'available';
        this.setState({ staff, activeTab, isLoading: false, lastTerm: name });
      },
      (error) => console.log(error)
    )
  };

  addStaff = (chef) => {
    const invited_chefs = [...(this.props.service.invited_chefs || [])];
    const rate = this.props.rate ? this.props.rate : chef.tier;
    invited_chefs.push({
      role: this.props.defaultRole || CHEF_ROLES['CHEF'],
      status: 'pending',
      rate,
      chef,
    });
    this.props.updateService({ invited_chefs }, { isStaffEdit: true, defaultRole: null });
  };

  componentDidUpdate(prevProps, _prevState) {
    // if it's opening, run search
    if (this.props.isOpen && !prevProps.isOpen) this.loadStaff();

    // if it's closing, clear it
    if (!this.props.isOpen && prevProps.isOpen)
      this.setState({ staff: this.staff, isLoading: false, searchTerm: '' });
  }
}

export default ServiceAddStaffModal;



// WEBPACK FOOTER //
// ./src/components/service/ServiceAddStaffModal.js